import {
    SEND_REMINDER_RESET,
    SEND_REMINDER_SUCCESS,
    SEND_REMINDER_FAILURE,
    FETCH_LINK_SUCCESS,
    FETCH_LINK_FAILURE,
    LINK_REDEMPTION_ACCOUNT,
    LINK_REDEMPTION_ACCOUNT_RESET
} from '../actions/index';
import {
    CONNECT_CARD, CONNECT_CARD_RESET, GET_GIFT, GET_GIFT_RESET, GET_GIFT_FROM_HASH, GET_GIFT_FROM_HASH_RESET, DISCONNECT_CARD, DISCONNECT_CARD_RESET,
    GET_EXCHANGE_OPTIONS, GET_EXCHANGE_OPTIONS_RESET, CONVERT_TO_E_GIFT, CONVERT_TO_E_GIFT_RESET, GET_E_GIFT,
    GET_E_GIFT_RESET, UPDATE_GIFT_BALANCE, UPDATE_GIFT_BALANCE_RESET, DELETE_REDEMPTION_ACCOUNT,
    DELETE_REDEMPTION_ACCOUNT_RESET, CREATE_GIFT_REDEMPTION_ACCOUNT_LINK, CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET,
    REORDER_GIFT, REORDER_GIFT_RESET, GET_RECEIVED_GIFTS, GET_RECEIVED_GIFTS_RESET, GET_SENT_GIFTS, GET_SENT_GIFTS_RESET, GET_ORDER, GET_ORDER_RESET, EXCHANGE_GIFT_MERCHANT, EXCHANGE_GIFT_MERCHANT_RESET,
    EXCHANGE_GIFT_VIRTUAL_VISA, EXCHANGE_GIFT_VIRTUAL_VISA_RESET,
    EXCHANGE_GIFT_PHYSICAL_VISA, EXCHANGE_GIFT_PHYSICAL_VISA_RESET,
    POLL_E_GIFT, POLL_E_GIFT_RESET, SEND_THANKYA, SEND_THANKYA_RESET,
    CHANGE_GIFT_RECIPIENT, CHANGE_GIFT_RECIPIENT_RESET,
    CHANGE_GIFT_DATE_SEND, CHANGE_GIFT_DATE_SEND_RESET,
    SELF_GIFT_CHANGE_GIFT_RECIPIENT, SELF_GIFT_CHANGE_GIFT_RECIPIENT_RESET,
    REFUND_GIFT, REFUND_GIFT_RESET,
    CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT, CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT_RESET, GIFTYA_SELECT_SELECT_MERCHANT, GIFTYA_SELECT_SELECT_MERCHANT_RESET
} from "../actions/gift";
const initialState = {
    linkRedemptionAccountSuccess: null,
    linkRedemptionAccountSuccessGiftId: null,
    linkRedemptionAccountFailure: null,
    gift: {},
    cardIsConnected: null,
    cardIsDisconnected: null,
    exchangeOptions: [],
    convertedToEGift: null,
    giftBalanceUpdated: null,
    updateGiftBalanceError: null,
    redemptionAccountIsDeleted: null,
    redemptionAccountLinkCreated: null,
    giftReordered: null,
    reorderGiftError: null,
    deleteRedemptionAccountError: null,
    receivedGifts: [],
    getReceivedGiftsError: null,
    getReceivedGiftsSuccess: null,
    sentGifts: [],
    getSentGiftsError: null,
    getSentGiftsSuccess: null,
    order: {items: []},
    getOrderSuccess: null,
    getOrderError: null,
    changeGiftRecipientSuccess: null,
    changeGiftRecipientError: null,
    changeGiftDateSendSuccess: null,
    changeGiftDateSendError: null,
    selfGiftChangeGiftRecipientSuccess: null,
    selfGiftChangeGiftRecipientError: null,
    connectCardError: null,
    exchangeGiftMerchantSuccess: null,
    exchangeGiftMerchantError: null,
    exchangeGiftVirtualVisaSuccess: null,
    exchangeGiftVirtualVisaError: null,
    exchangeGiftPhysicalVisaSuccess: null,
    exchangeGiftPhysicalVisaError: null,
    getEGiftSuccess: null,
    pollEGiftSuccess: null,
    pollEGiftRemainingCount: 0,
    pollEGiftError: null,
    sendThankYaSuccess: null,
    sendThankYaError: null,
    redemptionAccountLinkCreatedError: null,
    getGiftFromHashError: null,
    getGiftFromHashSuccess: null,
    deepLink: null,
    getGiftError: null,
    getGiftSuccess: null,
    disconnectCardError: null,
    refundGiftSuccess: null,
    refundGiftError: null,
    paymentMethodCreatedWithRedemptionMethodSuccess: null,
    paymentMethodCreatedWithRedemptionMethodError: null,
    giftyaSelectGiftHash: null,
    giftyaSelectSelectMerchantSuccess: null,
    giftyaSelectSelectMerchantError: null,
    changeGiftRecipientErrorMessage: null
};

export default function giftReducer(state = initialState, action) {
    switch (action.type) {
        case SEND_REMINDER_RESET:
            return {
                ...state,
                reminderWasSent: null,
                reminderSendError: null
            };
        case SEND_REMINDER_SUCCESS:
            return {
                ...state,
                phoneNumberWasUpdated: null,
                phoneNumberUpdateMessage: null,
                reminderWasSent: true,
                reminderSendError: false
            };
        case SEND_REMINDER_FAILURE:
            return {
                ...state,
                phoneNumberWasUpdated: null,
                phoneNumberUpdateMessage: null,
                reminderWasSent: false,
                reminderSendError: true
            };
        case FETCH_LINK_SUCCESS:
            return {
                ...state,
                link: action.data.data.redemption_url,
                fetchLinkFailure: false
            };
        case FETCH_LINK_FAILURE:
            return {
                ...state,
                fetchLinkFailure: true
            };
        case LINK_REDEMPTION_ACCOUNT:
            return {
                ...state,
                ...(action.meta.sent && {
                    linkRedemptionAccountSuccessGiftId: action.payload.giftId,
                    linkRedemptionAccountSuccess: true
                }),
                linkRedemptionAccountFailure: action.error
            };
        case LINK_REDEMPTION_ACCOUNT_RESET:
            return {
                ...state,
                linkRedemptionAccountSuccess: initialState.linkRedemptionAccountSuccess,
                linkRedemptionAccountFailure: initialState.linkRedemptionAccountFailure
            };
        case GET_GIFT:
            return {
                ...state,
                ...(action.meta.sent && {gift: action.payload}),
                ...(action.meta.sent && action.payload && {getGiftSuccess: true}),
                getGiftError: action.error
            };
        case GET_GIFT_RESET:
            return {
                ...state,
                getGiftError: initialState.getGiftError,
                getGiftSuccess: initialState.getGiftSuccess
            };
        case GET_GIFT_FROM_HASH:
            return {
                ...state,
                ...(action.payload.gift && {gift: action.payload.gift}),
                ...(action.payload.gift && {getGiftFromHashSuccess: true}),
                getGiftFromHashError: action.error
            };
        case GET_GIFT_FROM_HASH_RESET:
            return {
                ...state,
                getGiftFromHashSuccess: initialState.getGiftFromHashSuccess,
                getGiftFromHashError: initialState.getGiftFromHashError
            };
        case GET_E_GIFT:
            return {
                ...state,
                ...(action.meta.sent && {gift: action.payload.gift}),
                ...(action.payload.gift && {getEGiftSuccess: true}),
                error: action.error
            };
        case GET_E_GIFT_RESET:
            return {
                ...state,
                getEGiftSuccess: initialState.getEGiftSuccess
            };
        case POLL_E_GIFT:
            return {
                ...state,
                ...(action.payload.gift && {pollEGiftSuccess: true}),
                ...(action.payload.gift && {gift: action.payload.gift}),
                pollEGiftError: action.error,
                pollEGiftRemainingCount: action.payload.remainingCount
            };
        case POLL_E_GIFT_RESET:
            return {
                ...state,
                pollEGiftSuccess: initialState.pollEGiftSuccess,
                pollEGiftRemainingCount: initialState.pollEGiftRemainingCount,
                pollEGiftError: initialState.pollEGiftError
            };
        case CONNECT_CARD:
            return {
                ...state,
                gift: action.payload.gift || state.gift,
                ...(action.payload.cardIsConnected && {cardIsConnected: true}),
                connectCardError: action.error
            };
        case CONNECT_CARD_RESET:
            return {
                ...state,
                cardIsConnected: initialState.cardIsConnected,
                connectCardError: initialState.connectCardError
            };

        case CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT:
            return {
                ...state,
                ...(action.payload.paymentMethodCreatedWithRedemptionMethodSuccess && {paymentMethodCreatedWithRedemptionMethodSuccess: true}),
                paymentMethodCreatedWithRedemptionMethodError: action.error
            };
        case CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT_RESET:
            return {
                ...state,
                paymentMethodCreatedWithRedemptionMethodSuccess: initialState.paymentMethodCreatedWithRedemptionMethodSuccess,
                paymentMethodCreatedWithRedemptionMethodError: initialState.paymentMethodCreatedWithRedemptionMethodError
            };

        case DISCONNECT_CARD:
            return {
                ...state,
                ...(action.payload.cardIsDisconnected && {cardIsDisconnected: true}),
                disconnectCardError: action.error
            };
        case DISCONNECT_CARD_RESET:
            return {
                ...state,
                cardIsDisconnected: initialState.cardIsDisconnected,
                disconnectCardError: initialState.disconnectCardError

            };
        case DELETE_REDEMPTION_ACCOUNT:
            return {
                ...state,
                gift: action.payload.gift || state.gift,
                redemptionAccountIsDeleted: action.payload.redemptionAccountIsDeleted || state.redemptionAccountIsDeleted,
                deleteRedemptionAccountError: action.error
            };
        case DELETE_REDEMPTION_ACCOUNT_RESET:
            return {
                ...state,
                redemptionAccountIsDeleted: initialState.redemptionAccountIsDeleted,
                deleteRedemptionAccountError: initialState.deleteRedemptionAccountError
            };
        case GET_EXCHANGE_OPTIONS:
            return {
                ...state,
                ...(action.payload.exchangeOptions && {exchangeOptions: action.payload.exchangeOptions}),
                exchangeOptionsError: action.error
            };
        case GET_EXCHANGE_OPTIONS_RESET:
            return {
                ...state,
                exchangeOptions: initialState.exchangeOptions
            };
        case CONVERT_TO_E_GIFT:
            return {
                ...state,
                convertedToEGift: action.payload.data && action.payload.data.gift_type === 'egift',
                gift: action.payload.data || state.gift,
                convertToEGiftError: action.error
            };
        case CONVERT_TO_E_GIFT_RESET:
            return {
                ...state,
                convertedToEGift: initialState.convertedToEGift
            };
        case UPDATE_GIFT_BALANCE:
            return {
                ...state,
                giftBalanceUpdated: !!action.payload.data && !action.error,
                gift: action.payload.data || state.gift,
                updateGiftBalanceError: action.error
            };
        case UPDATE_GIFT_BALANCE_RESET:
            return {
                ...state,
                giftBalanceUpdated: initialState.giftBalanceUpdated,
                updateGiftBalanceError: initialState.updateGiftBalanceError
            };
        case CREATE_GIFT_REDEMPTION_ACCOUNT_LINK:
            return {
                ...state,
                ...(action.meta.sent && !action.error && {redemptionAccountLinkCreated: true}),
                redemptionAccountLinkCreatedError: action.error,
                linkRedemptionAccountFailure: action.error,
            };
        case CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET:
            return {
                ...state,
                redemptionAccountLinkCreated: initialState.redemptionAccountLinkCreated
            };
        case REORDER_GIFT:
            return {
                ...state,
                ...(action.meta.sent && !action.error && {giftReordered: true}),
                reorderGiftError: action.error,
            };
        case REORDER_GIFT_RESET:
            return {
                ...state,
                giftReordered: initialState.giftReordered,
                reorderGiftError: initialState.reorderGiftError
            };
        case GET_RECEIVED_GIFTS:
            return {
                ...state,
                ...(action.meta.sent && !action.error && {receivedGifts: action.payload}),
                ...(action.meta.sent && !action.error && {getReceivedGiftsSuccess: true}),
                getReceivedGiftsError: action.error,
            };
        case GET_RECEIVED_GIFTS_RESET:
            return {
                ...state,
                getReceivedGiftsSuccess: initialState.getReceivedGiftsSuccess,
                getReceivedGiftsError: initialState.getReceivedGiftsError
            };
        case GET_SENT_GIFTS:
            return {
                ...state,
                ...(action.payload.gifts && {sentGifts: action.payload.gifts}),
                ...(action.payload.gifts && {getSentGiftsSuccess: true}),
                getSentGiftsError: action.error,
            };
        case GET_SENT_GIFTS_RESET:
            return {
                ...state,
                getSentGiftsSuccess: initialState.getSentGiftsSuccess,
                getSentGiftsError: initialState.getSentGiftsError
            };
        case GET_ORDER:
            return {
                ...state,
                ...(action.payload.order && {order: action.payload.order}),
                ...(action.payload.order && {getOrderSuccess: true}),
                getOrderError: action.error,
            };
        case GET_ORDER_RESET:
            return {
                ...state,
                getOrderSuccess: initialState.getOrderSuccess,
                getOrderError: initialState.getOrderError
            };
        case CHANGE_GIFT_RECIPIENT:
            return {
                ...state,
                ...(action.payload.changeGiftRecipientSuccess && {
                    changeGiftRecipientSuccess: true
                }),
                ...(action.error && {
                    changeGiftRecipientErrorMessage: action.payload.message
                }),
                changeGiftRecipientError: action.error
            };
        case CHANGE_GIFT_RECIPIENT_RESET:
            return {
                ...state,
                changeGiftRecipientSuccess: initialState.changeGiftRecipientSuccess,
                changeGiftRecipientError: initialState.changeGiftRecipientError,
                changeGiftRecipientErrorMessage: initialState.changeGiftRecipientErrorMessage,
            };

        case CHANGE_GIFT_DATE_SEND:
            return {
                ...state,
                ...(action.payload.changeGiftDateSendSuccess && {changeGiftDateSendSuccess: true}),
                changeGiftDateSendError: action.error
            };
        case CHANGE_GIFT_DATE_SEND_RESET:
            return {
                ...state,
                changeGiftDateSendSuccess: initialState.changeGiftDateSendSuccess,
                changeGiftDateSendError: initialState.changeGiftDateSendError
            };


        case SELF_GIFT_CHANGE_GIFT_RECIPIENT:
            return {
                ...state,
                ...(action.payload.selfGiftChangeGiftRecipientSuccess && {selfGiftChangeGiftRecipientSuccess: true}),
                selfGiftChangeGiftRecipientError: action.error
            };
        case SELF_GIFT_CHANGE_GIFT_RECIPIENT_RESET:
            return {
                ...state,
                selfGiftChangeGiftRecipientSuccess: initialState.selfGiftChangeGiftRecipientSuccess,
                selfGiftChangeGiftRecipientError: initialState.selfGiftChangeGiftRecipientError
            };


        case REFUND_GIFT:
            return {
                ...state,
                ...(action.payload.refundGiftSuccess && {refundGiftSuccess: true}),
                refundGiftError: action.error
            };
        case REFUND_GIFT_RESET:
            return {
                ...state,
                refundGiftSuccess: initialState.refundGiftSuccess,
                refundGiftError: initialState.refundGiftError
            };


        case EXCHANGE_GIFT_MERCHANT:
            return {
                ...state,
                ...(action.payload.gift && {
                    gift: action.payload.gift,
                    exchangeGiftMerchantSuccess: true
                }),
                ...(action.payload.exchangedGift && {exchangedGift: action.payload.exchangedGift}),
                exchangeGiftMerchantError: action.error
            };
        case EXCHANGE_GIFT_MERCHANT_RESET:
            return {
                ...state,
                exchangeGiftMerchantSuccess: initialState.exchangeGiftMerchantSuccess,
                exchangeGiftMerchantError: initialState.exchangeGiftMerchantError
            };
        case EXCHANGE_GIFT_VIRTUAL_VISA:
            return {
                ...state,
                ...(action.payload.virtualVisaGift && {virtualVisaGift: action.payload.virtualVisaGift}),
                ...(action.payload.virtualVisaGift && {exchangeGiftVirtualVisaSuccess: true}),
                exchangeGiftVirtualVisaError: action.error
            };
        case EXCHANGE_GIFT_VIRTUAL_VISA_RESET:
            return {
                ...state,
                exchangeGiftVirtualVisaSuccess: initialState.exchangeGiftVirtualVisaSuccess,
                exchangeGiftVirtualVisaError: initialState.exchangeGiftVirtualVisaError
            };
        case EXCHANGE_GIFT_PHYSICAL_VISA:
            return {
                ...state,
                ...(action.payload.physicalVisaGift && {physicalVisaGift: action.payload.physicalVisaGift}),
                ...(action.payload.physicalVisaGift && {exchangeGiftPhysicalVisaSuccess: true}),
                exchangeGiftPhysicalVisaError: action.error
            };
        case EXCHANGE_GIFT_PHYSICAL_VISA_RESET:
            return {
                ...state,
                exchangeGiftPhysicalVisaSuccess: initialState.exchangeGiftPhysicalVisaSuccess,
                exchangeGiftPhysicalVisaError: initialState.exchangeGiftPhysicalVisaError
            };
        case SEND_THANKYA:
            return {
                ...state,
                ...(action.payload.sendThankYaSuccess && {sendThankYaSuccess: true}),
                sendThankYaError: action.error
            };
        case SEND_THANKYA_RESET:
            return {
                ...state,
                sendThankYaSuccess: initialState.sendThankYaSuccess,
                sendThankYaError: initialState.sendThankYaError
            };
        case GIFTYA_SELECT_SELECT_MERCHANT:
            return {
                ...state,
                ...(action.meta.sent && {
                    giftyaSelectSelectMerchantSuccess: true,
                    giftyaSelectGiftHash: action.payload.giftyaSelectGiftHash
                }),
                giftyaSelectSelectMerchantError: action.error
            };
        case GIFTYA_SELECT_SELECT_MERCHANT_RESET:
            return {
                ...state,
                giftyaSelectSelectMerchantSuccess: initialState.giftyaSelectSelectMerchantSuccess,
                giftyaSelectSelectMerchantError: initialState.giftyaSelectSelectMerchantError
            };
        default:
            return state;
    }
}